import { bindActionCreators } from "redux";
import { useRouter } from "next/router";
import { connect } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { useState } from "react";

import {
  showAppModal,
  followCategory,
  unfollowCategory,
} from "redux/actions/app";

import { Button, Modal } from "antd";
import { isWechatBrowser, authUrlSilently } from "~/utils/wechat";
import { findMatchingEle } from "~/utils/app";
import { isMobile } from "react-device-detect";

const isWechat = isWechatBrowser();

const CategoryFollowButton = ({
  name = "版块",
  className,
  category,
  onFollow,
  onUnfollow,
  onFollowed,
  onUnfollowed,
  isFollowed = false,
  disabled = false,
  token,
  user,
  flags,
  followCategory,
  unfollowCategory,
  showAppModal,
  followButtonType = "primary",
  unfollowButtonType = "default",
  followText = "关注",
  unfollowText = "取关",
}: any) => {
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  return (
    <>
      {isFollowed ? (
        <Button
          disabled={loading || disabled}
          size="small"
          shape="round"
          type={unfollowButtonType}
          className={`${className}`}
          onClick={() => {
            onUnfollow
              ? onUnfollow()
              : Modal.confirm({
                  title: "确认退出吗？",
                  content: `退出后你可能会错过该${name}下的精彩帖子和活动哦`,
                  onOk() {
                    unfollowCategory(token, category.id)
                      .then((c: any) => {
                        if (onUnfollowed) onUnfollowed(c);
                      })
                      .finally(() => setLoading(false));
                  },
                });
          }}
        >
          {unfollowText}
        </Button>
      ) : (
        <Button
          disabled={loading || disabled}
          icon={!isMobile && <PlusOutlined />}
          size="small"
          shape="round"
          type={followButtonType}
          className={`${className}`}
          onClick={() => {
            if (onFollow) {
              onFollow();
              return;
            }

            if (token) {
              const cost = findMatchingEle(category);
              if (cost === 0 || flags.paid.includes(category.hashid)) {
                followCategory(token, category.id)
                  .then((c: any) => {
                    if (onFollowed) onFollowed(c);
                  })
                  .finally(() => setLoading(false));
                return;
              }
              if (user.ele >= cost) {
                Modal.confirm({
                  title: `确认要加入该${name}吗？`,
                  content: `您现在的剩余电量 ${user.ele}，加入需要消耗 ${cost} 电量`,
                  onOk() {
                    followCategory(token, category.id)
                      .then((c: any) => {
                        if (onFollowed) onFollowed(c);
                      })
                      .finally(() => setLoading(false));
                  },
                });
              } else {
                Modal.confirm({
                  title: "电量余额不足",
                  okText: "去充电",
                  content: `加入需要消耗 ${cost} 电量，您的电量余额为 ${user.ele} 电量，是否去充电？`,
                  onOk() {
                    if (isWechat) {
                      router.push({
                        pathname: "/profile/info",
                        query: { redirectUrl: router.asPath },
                      });
                    } else {
                      showAppModal("TopUpModal");
                    }
                  },
                });
              }
            } else {
              showAppModal("PhoneSigninModal");
            }
          }}
        >
          {followText}
        </Button>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.user.token,
  user: state.user.user,
  flags: state.app.flags,
});
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      showAppModal,
      unfollowCategory,
      followCategory,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryFollowButton);
